import React from "react";

function DPendingApprovalSvgComponent(props: any) {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <defs>
    <clipPath id="clip-path-pa">
      <rect id="Rectangle_19846" data-name="Rectangle 19846" width="24" height="24" transform="translate(-8775 381)" fill="#fff"/>
    </clipPath>
  </defs>
  <g id="Mask_Group_449" data-name="Mask Group 449" transform="translate(8775 -381)" clip-path="url(#clip-path-pa)">
    <path id="approval_24dp_FILL0_wght300_GRAD0_opsz24" d="M6.052-8.4v-5.862a2.007,2.007,0,0,1,.56-1.438,1.817,1.817,0,0,1,1.368-.588H20.124a1.817,1.817,0,0,1,1.368.588,2.007,2.007,0,0,1,.56,1.438V-8.4Zm1.6-3.922h12.8v-1.94a.337.337,0,0,0-.1-.237.307.307,0,0,0-.226-.108H7.98a.307.307,0,0,0-.226.108.337.337,0,0,0-.1.237v1.94Zm6.4-3.966-4.8-6.961v-.108a4.989,4.989,0,0,1,1.4-3.571,4.518,4.518,0,0,1,3.4-1.472,4.518,4.518,0,0,1,3.4,1.472,4.989,4.989,0,0,1,1.4,3.571v.108Zm0-2.438,3.2-4.631a3.327,3.327,0,0,0-.933-2.381,3.013,3.013,0,0,0-2.267-.981,3.013,3.013,0,0,0-2.267.981,3.327,3.327,0,0,0-.933,2.381ZM14.052-22.724Z" transform="translate(-8777.052 411.397)" fill="#1a73e8"/>
  </g>
</svg>
    </>
  );
}

export default DPendingApprovalSvgComponent;
